import { render } from "./FleetManagerDashboard.vue?vue&type=template&id=0beaec10&scoped=true"
import script from "./FleetManagerDashboard.vue?vue&type=script&lang=js"
export * from "./FleetManagerDashboard.vue?vue&type=script&lang=js"

import "./FleetManagerDashboard.vue?vue&type=style&index=0&id=0beaec10&lang=css"
import "./FleetManagerDashboard.vue?vue&type=style&index=1&id=0beaec10&scoped=true&lang=css"

import exportComponent from "D:\\CTS_SURAJ\\TRAVEL SAFE\\kite-app-api\\ui-code\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0beaec10"]])

export default __exports__